"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var keys_1 = require("./keys");
var keys = defaultState();
function defaultState() {
    var defaultState = {
        pressed: false,
        justPressed: false,
        released: false,
        justReleased: false
    };
    return keys_1.default.reduce(function (acc, key) {
        var label = key.name;
        delete key['label'];
        acc[label] = __assign(__assign({}, key), defaultState);
        return acc;
    }, {});
}
function getKey(event, keys) {
    var result = null;
    var objectKeys = Object.keys(keys);
    for (var i = 0; i < objectKeys.length; i++) {
        if (keys[objectKeys[i]].code === event.code) {
            result = keys[objectKeys[i]];
        }
    }
    if (!result) {
        console.error("No key definition found for ".concat(event.code));
    }
    return result;
}
function preventDefaultArrows(event) {
    var keys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' '];
    if (keys.includes(event.key)) {
        event.preventDefault();
    }
}
function down(event) {
    preventDefaultArrows(event);
    var key = getKey(event, keys);
    if (!key.pressed) {
        key.justPressed = true;
    }
    key.pressed = true;
}
function up(event) {
    var key = getKey(event, keys);
    if (!key.released) {
        key.justReleased = true;
    }
    key.pressed = false;
    key.released = true;
}
function update() {
    // reset the keys "just" properties
    Object.keys(keys).forEach(function (key) {
        keys[key].justPressed = false;
        keys[key].justReleased = false;
    });
}
function create(canvas) {
    var start = function () {
        // keyboard events
        canvas.addEventListener('keydown', down);
        canvas.addEventListener('keyup', up);
    };
    return {
        start: start,
        update: update,
        getState: function () { return keys; }
    };
}
exports.default = { create: create };
